import { CitationSource } from 'types/chat-message'

type ImageCitationProps = {
  source?: CitationSource
}

/** Inline image citation ([img:N]): the image when ready, a skeleton while loading. */
export const ImageCitation = ({ source }: ImageCitationProps) => {
  if (!source?.imageUrl) {
    return (
      <span className="tw-block tw-my-2 tw-rounded-lg tw-overflow-hidden tw-max-w-[280px] tw-h-[160px] tw-bg-neutral-200 tw-animate-pulse" />
    )
  }

  return (
    <a
      href={source.imageUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="tw-block tw-my-2 tw-rounded-lg tw-overflow-hidden tw-border tw-border-neutral-200 tw-shadow-sm hover:tw-shadow-md tw-transition-shadow tw-max-w-[280px]"
    >
      <img src={source.imageUrl} alt={source.name} className="tw-w-full tw-h-auto tw-object-contain" loading="lazy" />
      {source.name && source.name !== 'Unknown' && (
        <span className="tw-flex tw-items-center tw-gap-1.5 tw-px-2 tw-py-1 tw-bg-neutral-50 tw-border-t tw-border-faint">
          <span className="tw-text-xs tw-text-muted tw-truncate">{source.name}</span>
        </span>
      )}
    </a>
  )
}
